module.exports = new __parcel__URL__("shop_machines_saved_souls.1ae40a73.png").toString();